module.exports = __webpack_public_path__ + "img/img-6.f476dfbb.png";